// extracted by mini-css-extract-plugin
module.exports = {"media":"Media_media__oBzd3","placeholder":"Media_placeholder__sx6mJ"};